enum PackageMode {
  DEBIAN = 'DEBIAN',
  TORIZON = 'TORIZON',
}

export default PackageMode;
